import React from 'react';
import api from '../../../api';
import { IGetAnnouncementsRes, IGetAnnouncementsParams } from '@/types/api/announcement/getAnnouncements';

export const useFetchAnnouncements = (
  shouldInitFetch: boolean = true, //初回fetchをするかどうか
  lang: string = 'ja',
  from: string | null = null,
) => {
  const [announcements, setAnnouncements] = React.useState<IGetAnnouncementsRes>();

  const fetchAnnouncements = async (
    lang = 'ja',
    from: string | null = null,
  ) => {
    const params: IGetAnnouncementsParams = { lang, from };
    const result = await api.get('/announcements', {
      params,
      timeout: 5 * 60 * 1000, // 5分に設定
    });

    // お知らせ情報
    setAnnouncements(result);
  };

  React.useEffect(() => {
    if (!shouldInitFetch) return;
    fetchAnnouncements(lang, from);
  }, []);

  return { announcements, fetchAnnouncements };
};
